import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const EmployeeStatsWidgets = ({ stats }) => {
    const cards = [
        {
            title: "Today's Orders",
            value: stats?.today_orders || 0,
            icon: "mdi mdi-clipboard-text-clock-outline",
            color: "primary",
            badgeText: "Daily Intake",
            badgeColor: "soft-primary"
        },
        {
            title: "Month's Total Entries",
            value: stats?.month_orders || 0,
            icon: "mdi mdi-calendar-check-outline",
            color: "success",
            badgeText: "This Month",
            badgeColor: "soft-success"
        },
        {
            title: "Orders Due Today",
            value: stats?.due_today || 0,
            icon: "mdi mdi-clock-alert-outline",
            color: stats?.due_today > 0 ? "warning" : "info",
            badgeText: stats?.due_today > 0 ? "Urgent Action" : "On Track",
            badgeColor: stats?.due_today > 0 ? "soft-warning" : "soft-info"
        },
        {
            title: "Edit Approvals",
            value: stats?.pending_approvals || 0,
            subValue: stats?.approved_ready ? `${stats.approved_ready} Ready to Edit` : "0 Ready",
            icon: "mdi mdi-shield-check-outline",
            color: stats?.approved_ready > 0 ? "success" : stats?.pending_approvals > 0 ? "warning" : "secondary",
            badgeText: stats?.approved_ready > 0 ? "Permission Ready" : "Review Status",
            badgeColor: stats?.approved_ready > 0 ? "soft-success" : "soft-warning"
        }
    ];

    return (
        <Row className="mb-3 g-3">
            {cards.map((card, index) => (
                <Col xl={3} md={6} key={index}>
                    <Card className="mini-stats-wid shadow-sm border-0 h-100" style={{ borderRadius: "10px" }}>
                        <CardBody className="p-3">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <p className="text-muted fw-semibold mb-1 font-size-13 text-uppercase">{card.title}</p>
                                    <h4 className="mb-0 fw-bold text-dark">{card.value}</h4>
                                    {card.subValue && (
                                        <small className="text-success fw-semibold mt-1 d-block font-size-12">
                                            <i className="mdi mdi-check-circle me-1"></i>
                                            {card.subValue}
                                        </small>
                                    )}
                                </div>
                                <div className={`avatar-sm rounded-circle bg-${card.color} bg-soft align-self-center mini-stat-icon`}>
                                    <span className="avatar-title rounded-circle bg-transparent text-primary">
                                        <i className={`${card.icon} font-size-24 text-${card.color}`}></i>
                                    </span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default EmployeeStatsWidgets;
